import type { FeedThread as FeedThreadSnapshot, LiveFeed } from '@localagent/sdk';
import { FeedPostCard } from './FeedPostCard';

export function FeedThread({
  thread,
  liveFeed,
}: {
  thread: FeedThreadSnapshot;
  liveFeed?: LiveFeed;
}) {
  return (
    <section data-testid="feed-thread" className="space-y-3">
      {thread.root ? <FeedPostCard post={thread.root} liveFeed={liveFeed} /> : null}
      {thread.ancestors.map((post) => (
        <FeedPostCard key={post.id} post={post} liveFeed={liveFeed} />
      ))}
      <FeedPostCard post={thread.focused} liveFeed={liveFeed} />
      {thread.replies.map((post) => (
        <FeedPostCard key={post.id} post={post} liveFeed={liveFeed} />
      ))}
      {thread.truncated ? (
        <p className="text-caption text-muted-foreground" data-testid="feed-thread-truncated">
          Older replies are not shown.
        </p>
      ) : null}
    </section>
  );
}
